import { createFileRoute, redirect } from '@tanstack/react-router';

/** Paige Scan joined Devices as one page, Scanners and devices (Dustin, 2026-10-03); the old address opens it there. */
export const Route = createFileRoute('/t/$tenant/settings/company/scan')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/t/$tenant/settings/company/devices',
      params: { tenant: params.tenant },
      hash: 'paige-scan',
      replace: true,
    });
  },
});
